import { ErrorHandler } from '@frontend/error-handler';
import { useActiveModal, useModals } from '@frontend/modal';
import { ScheduleClient } from '@frontend/report/api';
import { useState } from 'react';

import { UpdateReceiversModalProps } from './update-receivers-modal.component';

export const useUpdateReceiversModal = (props: UpdateReceiversModalProps) => {
    const { modalId } = useActiveModal();
    const { closeModal } = useModals();
    const [selectedReceivers, setSelectedReceivers] = useState<string[]>(props.schedule.receivers || []);

    const onCancel = () => {
        closeModal(modalId);
    };

    const onSubmit = () => {
        ScheduleClient.patchSchedule(props.schedule.account_id, props.schedule.report_id, props.schedule.id, { receivers: selectedReceivers })
            .then(() => {
                onCancel();
            })
            .catch((err) => ErrorHandler.handleError({ error: err }));
    };

    return {
        selectedReceivers,
        setSelectedReceivers,
        onSubmit,
        onCancel
    };
};
